import { setSecurityModalOpen } from '@/lib/features/ui/uiSlice'
import { useAppDispatch, useAppSelector } from '@/lib/hooks'

export const useSecurityModal = () => {
  const dispatch = useAppDispatch()
  const isOpen = useAppSelector((state) => state.ui.securityModalOpen)

  const setOpen = () => {
    dispatch(setSecurityModalOpen(true))
  }

  const setClose = () => {
    dispatch(setSecurityModalOpen(false))
  }

  return {
    isOpen,
    setOpen,
    setClose,
  }
}
